"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.classnames = classnames;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function classnames() {
  var classes = [];

  for (var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++) {
    classNames[_key] = arguments[_key];
  }

  var _loop = function _loop() {
    var cls = _classNames[_i];

    if (!cls) {
      return "continue";
    }

    if (typeof cls === 'string') {
      classes.push(cls);
    } else if (Array.isArray(cls)) {
      cls.forEach(function (item) {
        if (item) {
          classes.push(item);
        }
      });
    } else if (_typeof(cls) === 'object' && cls) {
      Object.keys(cls).forEach(function (key) {
        if (cls[key]) {
          classes.push(key);
        }
      });
    }
  };

  for (var _i = 0, _classNames = classNames; _i < _classNames.length; _i++) {
    var _ret = _loop();

    if (_ret === "continue") continue;
  }

  return classes.join(' ');
}